import { useDocumentTitle } from "$utils/document-title";
import React from "react";
import MetricsAdmin from "./pages/metrics";

const AdminIndex = () => {
    useDocumentTitle("Admin");
    return (
        <div>
            <MetricsAdmin />
        </div>
    );
};

export default AdminIndex;
